import React from 'react';

import { AverageRating } from '../bar-rating';

import './bar-rating-item.scss';

interface BarRatingItemProps {
  averageRating?: AverageRating;
}

function BarRatingItem(props: BarRatingItemProps) {
  const { averageRating } = props;

  return (
    <div styleName="average-rating">
      <span styleName="average-rating-title">{averageRating?.label}</span>
      <div styleName="average-rating-bar">
        <span
          style={{
            width: `${((averageRating?.value || 0) / 5) * 100}%`
          }}
          styleName="average-rating-bar-fill"
        />
      </div>
      <span styleName="average-rating-value">
        {averageRating?.value?.toFixed(1)}
      </span>
    </div>
  );
}

export default BarRatingItem;
